export const getProducts = async (
  page,
  limit,
  characteristicFilters, // Фильтры, собранные динамически
  authToken
) => {
  try {
    const params = new URLSearchParams();

    if (page != null) params.set('page', String(page));
    if (limit != null) params.set('limit', String(limit));
    if (characteristicFilters && typeof characteristicFilters === 'object') {
      Object.entries(characteristicFilters).forEach(([name, raw]) => {
        if (!raw) return;
        const values = Array.isArray(raw)
          ? raw
          : String(raw).split(',').map(s => s.trim()).filter(Boolean);

        if (values.length) {
          const value = values.length === 1 ? values[0] : values.join(',');
          params.append(name, value); // без props[]
        }
      });
    }

    // Заголовки с Bearer токеном
    const token =
      authToken ||
      (typeof window !== 'undefined' && localStorage.getItem('API_TOKEN')) ||
      process.env.NEXT_PUBLIC_API_TOKEN;

    const headers = { Accept: 'application/json' };
    if (token) headers.Authorization = `Bearer ${token}`;

    // Выполняем GET запрос
    const res = await fetch(`https://woh-crm.worldofheels.com.ua/v1/catalog/products?${params.toString()}`, {
      method: 'GET',
      headers,
    });

    if (res.status === 401) {
      throw new Error('Unauthorized (401): проверьте Bearer токен');
    }

    if (!res.ok) {
      throw new Error(`Failed to fetch products: ${res.status}`);
    }

    const data = await res.json();

    const products = Array.isArray(data?.products)
      ? data.products
      : Array.isArray(data?.items)
        ? data.items
        : Array.isArray(data?.data)
          ? data.data
          : [];

    const normalized = { ...data, products };

    // Фильтрация по видимости
    if (Array.isArray(normalized.products)) {
      normalized.products = normalized.products.filter(p => p?.isVisible === true);
    }

    return normalized;
  } catch (e) {
    console.error('Error fetching products (GET):', e);
    throw e;
  }
};
